import React, { useEffect, useRef, useState } from "react";
import { Modal, message, Button } from "antd";
import MaterialTable from "material-table";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { DeletePromotion, GetPromotions } from "../../../utils/api";
import DeleteIcon from "../../../../src/assets/delete-icon.png";
import tableIcons from "../../../utils/tableIcons";
import { overlayContainer } from "../../../utils/overlayContainer";
import { commonDateFormat } from "../../../utils/helper";
// import Loader from "../../../components/shared/Loader";

const ExpiredPromotions = ({ updatePromotionData }) => {
  const tableRef = useRef(null);
  const [modalData, setModalData] = useState({
    visible: false,
    user: null,
    id: null,
    action: null,
  });
  const [query, setQuery] = useState({
    page: 0,
    pageSize: 25,
    search: "",
    orderField: "",
    orderDirection: "",
    customFilter: "",
  });
  const [, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const columns = [
    {
      title: "Code Name",
      field: "name",
      cellStyle: { width: "15%" },
      sorting: true,
    },
    {
      title: "Discount",
      field: "discount",
      cellStyle: { width: "10%" },
      sorting: true,
      render: (record) => {
        return (
          <span>
            {record?.discountType !== "percentage" && "£"}
            {record.discount}
            {record?.discountType === "percentage" && "%"}
          </span>
        );
      },
    },
    {
      title: "Description",
      field: "description",
      cellStyle: { width: "15%" },
      sorting: true,
    },
    {
      title: "Expiry Date",
      field: "endDate",
      cellStyle: { width: "15%" },
      sorting: false,
      render: (record) => {
        return <span>{commonDateFormat(record?.endDate)}</span>;
      },
    },
    {
      title: "Category",
      field: "categoryNames",
      cellStyle: { width: "25%" },
      sorting: false,
      render: (record) => {
        return <span>{record?.categoryNames}</span>;
      },
    },
    {
      title: "Usage Limits",
      field: "usageLimit",
      cellStyle: { width: "15%" },
      sorting: false,
      render: (record) => {
        return <span>{record?.usageLimit} clients</span>;
      },
    },
    {
      title: "Action",
      sorting: false,
      cellStyle: { width: "10%" },
      render: (record) => {
        return (
          <span
            className="client-delete-icon cursor-pointer flex items-center justify-center"
            onClick={() => handleActionModalOpen("delete", record)}
          >
            <img alt="show-icon" src={DeleteIcon} width={20} />
          </span>
        );
      },
    },
  ];

  const fetchData = async (dataquery) => {
    setLoading(true);

    let params = "type=admin&status=expired";
    params += `&pageNo=${dataquery?.page + 1}`;
    params += `&limit=${dataquery?.pageSize}`;

    if (dataquery?.search) {
      params += `&search=${dataquery.search}`;
    }

    if (dataquery?.orderBy) {
      params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
    }

    const response = await GetPromotions(params);

    setLoading(false);

    return {
      data: response?.items,
      page: dataquery?.page,
      totalCount: response?.totalRecords,
    };
  };

  const handleActionModalOpen = (action, data) => {
    if (action === "delete") {
      setModalData({
        visible: true,
        user: data.name,
        id: data.id,
        action: "delete",
      });
    } else if (action === "update") {
      setModalData({
        visible: true,
        user: data.name,
        id: data.id,
        action: "update",
      });
    }
  };

  const handleDeleteOk = async () => {
    if (modalData.action === "delete") {
      try {
        setBtnLoading(true);
        const res = await DeletePromotion(modalData?.id);
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success("Promocode Deleted successfully");
          setModalData({
            id: null,
            visible: false,
            selectedStatus: null,
            user: null,
            action: null,
          });
          if (
            tableRef.current?.state?.query?.page + 1 ===
            tableRef.current?.state?.query?.totalCount
          ) {
            setQuery((prev) => ({ ...prev, page: prev.page - 1 }));
            tableRef.current.onQueryChange({ ...query, page: query.page - 1 });
          }
          tableRef.current.onQueryChange();
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in deletion, Try again later");
      }
    }
  };

  const handleModalCancel = () => {
    setModalData({
      visible: false,
      selectedStatus: null,
      user: null,
      id: null,
      action: null,
    });
  };

  useEffect(() => {
    tableRef.current.onQueryChange();
  }, [updatePromotionData]);

  return (
    <div className="searchposotion table-scroll poppins">
      <MaterialTable
        title="Clients"
        tableRef={tableRef}
        columns={columns}
        icons={tableIcons}
        page={query.page}
        options={{
          showTitle: false,
          draggable: false,
          paging: true,
          sorting: true,
          pageSize: Number(query.pageSize),
          pageSizeOptions: [10, 25, 50, 100],
          debounceInterval: 700,
          padding: "dense",
          paginationType: "stepped",
          searchFieldVariant: "outlined",
          searchFieldAlignment: "left",
        }}
        data={(query) => fetchData(query)}
        onChangeRowsPerPage={(pageSize) => {
          setQuery((prev) => ({ ...prev, pageSize: Number(pageSize) }));
        }}
        onChangePage={(page) =>
          setQuery((prev) => ({ ...prev, page: Number(page) }))
        }
        components={{
          Pagination: (props) => {
            const {
              page,
              rowsPerPage,
              count,
              onChangePage,
              onChangeRowsPerPage,
            } = props;
            return (
              <div
                className="box-shadow-pagination text-sm"
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px 20px",
                  marginTop: "20px",
                }}
              >
                <div className="bottom-pagination-text">
                  <button
                    className="disabled:opacity-50"
                    onClick={(e) => {
                      onChangePage(e, page - 1);
                    }}
                    disabled={page === 0}
                  >
                    <LeftOutlined />
                  </button>
                  <span style={{ margin: "0 10px" }}>
                    {page + 1} of {Math.ceil(count / rowsPerPage)}
                  </span>
                  <button
                    className="disabled:opacity-50"
                    onClick={(e) => {
                      onChangePage(e, page + 1);
                    }}
                    disabled={
                      page === Math.ceil(count / rowsPerPage) - 1 ||
                      tableRef.current?.dataManager?.data?.length === 0
                    }
                  >
                    <RightOutlined />
                  </button>
                </div>
                <div style={{ position: "absolute", right: "25px" }}>
                  <span style={{ margin: "0 10px" }}>Items per page:</span>
                  <select
                    className="pagination-select"
                    disabled={tableRef.current?.dataManager?.data?.length === 0}
                    value={rowsPerPage}
                    onChange={(e) => {
                      onChangeRowsPerPage(e, e.target.value);
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
              </div>
            );
          },
          OverlayLoading: (props) => {
            return <div style={overlayContainer}>{/* <Loader /> */}</div>;
          },
        }}
      />

      <Modal
        centered
        title={
          modalData.action === "delete"
            ? "Confirm Delete"
            : modalData?.action === "update"
            ? "Confirm Status Change"
            : "Confirm Selection Delete"
        }
        open={modalData.visible}
        onCancel={handleModalCancel}
        footer={
          <div>
            <Button onClick={handleModalCancel}>Cancel</Button>
            <Button
              type="primary"
              className="text-white"
              onClick={
                modalData.action === "delete" ? handleDeleteOk : () => {}
              }
            >
              Ok
              {btnLoading && (
                <span className="loader ml-2 align-middle mb-1"></span>
              )}
            </Button>
          </div>
        }
      >
        {modalData.action === "delete"
          ? `Are you sure you want to delete ${modalData.user}?`
          : ""}
      </Modal>
    </div>
  );
};

export default ExpiredPromotions;
